import React from 'react'
import classNames from 'classnames'

export default function SubSidebarItem({
    component,
    label,
    icon,
    href,
    onClick,
    active
}) {

    const Classes = classNames({
        'group flex items-center md:mx-3 px-5 md:px-3 py-1 transition-all rounded-lg': true,
        'hover:bg-extralightprimary': !active,
        'bg-extralightprimary': active
    })

    const Component = component || 'div';
    const Icon = icon;

    return (
        <Component to={href} className={Classes} onClick={onClick} title={label}>
            {icon &&
                <Icon className={`w-6 h-6 mr-2 ${!active ? 'fill-extralightprimary opacity-20' : 'fill-white opacity-50'}`} />
            }
            <div className={`text-md ${active && 'text-primary'}`}>{label}</div>
        </Component>
    )
}
